module.exports = __webpack_public_path__ + "static/landing_1-a96d6948886ddf6811b2e52f7a76e631.png";